<template>
  <div class="hero">
    <div class="landing">
      <div class="guide">
        <div
          id="signupMain1"
          class="d-flex align-center justify-center w-112 h-24 white--text mb-4"
          style="background-color: #3a3a3a; line-height: 26px; border-radius: 30px; padding: 4px 12px 4px 12px">
          지인 추천율 80%
        </div>
        <h1>
          <b class="desktop-text">검증된 블로그 리뷰로<br />찾아오는 손님을 늘려보세요.</b>
          <b class="mobile-text">검증된 블로그 리뷰로<br />방문 손님을 늘려보세요.</b>
        </h1>
        <p style="line-height: 30px">
          영향력이 검증된 상위 블로거만 선별했습니다.<br />
          슈퍼멤버스 월별 구독으로 바빠지는 매장을 경험하세요!
        </p>
        <router-link v-if="userIsAuthenticated" to="/company/modads">
          <button id="signupMain1" class="signup newPrimaryBg pl-4 py-0" style="line-height: 26px">
            무료 상담하기
            <v-icon style="color: #fff; margin: 0 0 2px 4px">chevron_right</v-icon>
          </button>
        </router-link>
        <button
          v-else
          id="signupMain2"
          class="signup newPrimaryBg pl-4 py-0"
          style="line-height: 26px"
          @click="showLeadModal = true">
          무료 상담하기
          <v-icon style="color: #fff; margin: 0 0 2px 4px" icon="chevron_right">chevron_right</v-icon>
        </button>
        <v-row justify="center" align="center" style="max-height: 0px">
          <ConsultDialog :show.sync="showConsultDialog" />
          <LeadModal :showModal.sync="showLeadModal" />
        </v-row>
      </div>

      <img
        v-if="$vuetify.breakpoint.mdAndUp"
        :src="require(`@/assets/img/landing/ceo-landing/landing-logo.png`)"
        :style="{
          width: '596px',
          marginLeft: '70px',
        }" />
      <img
        v-else
        :src="require(`@/assets/img/landing/ceo-landing/landing-logo-mobile.png`)"
        :style="{
          width: $vuetify.breakpoint.smAndUp ? '400px' : '100%',
          maxWidth: '400px',
          objectFit: 'contain',
        }" />
    </div>
    <!-- </v-parallax> -->
    <Fab v-if="!showLeadModal" :showLeadModal.sync="showLeadModal" />
  </div>
</template>

<script>
import userMixin from '@/components/shared/userMixin';
import ConsultDialog from '@/components/company/ConsultDialog';
import LeadModal from '@/components/landing/modal/LeadModal.vue';
import Fab from './Fab.vue';

export default {
  name: 'Landing',
  mixins: [userMixin],
  components: { ConsultDialog, LeadModal, Fab },
  mounted() {
    window.setInterval(() => {
      this.updatePrimary();
    }, 8600);

    let pipedriveScript = document.createElement('script');
    pipedriveScript.setAttribute('src', 'https://webforms.pipedrive.com/f/loader');
    document.head.appendChild(pipedriveScript);
  },
  methods: {
    updatePrimary: function () {
      this.$nextTick(function () {
        this.primary = (this.primary + 1) % 4;
      });
    },
    moveBlogSite() {
      location.href = 'https://rank.supermembers.co.kr/';
    },
  },
  data() {
    return {
      showConsultDialog: false,
      showLeadModal: false,
    };
  },
};
</script>

<style scoped lang="scss">
.hero {
  background-color: #fff;
}

.landing {
  // height: 592px;
  display: flex;
  overflow: hidden;
  margin: 0 auto;
  padding-top: 270px;
  // justify-content: space-between;
  justify-content: center;
  padding-bottom: 300px;
  * {
    user-select: none;
    -moz-user-select: none;
    -webkit-user-drag: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }
  .guide {
    // margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 0 16px 0 16px;

    // margin-right: 55px;
    h1 {
      line-height: 1.2;
      margin-bottom: 32px;
      font-weight: 300 !important;
      color: #0f1633;
      b {
        font-weight: 700;
      }
    }
    p {
      color: #1b2b43;
      margin-bottom: 56px;
      font-size: 15px;
      line-height: 1.79;
      letter-spacing: 0.01em;
    }
  }
}

.mobile-text {
  display: none;
}

.desktop-text {
  display: inline;
}

@media (max-width: 724px) {
  .hero {
    // background-image: url('../../assets/img/landing/hero_tinyfied.jpg');
  }
  .landing {
    // height: calc(100vh - 120px);
    padding: 50px 0 0 0;
    flex-direction: column;
    text-align: center;
    align-items: center;
    gap: 48px;
    .guide {
      text-align: center;
      align-items: center;
      h1 {
        font-size: 28px;
        line-height: 1.2;
        margin-bottom: 30px;
        letter-spacing: 0.02em !important;
      }
      p {
        margin-bottom: 50px;
        font-size: 14px;
        line-height: 1.79;
        // display: none;
      }
      #blogButton {
        margin-bottom: 40px;
      }
    }
  }

  .mobile-text {
    display: inline;
  }

  .desktop-text {
    display: none;
  }
}

.signup {
  width: 220px;
  height: 48px;
  border-radius: 24px;
  box-shadow: 0 12px 24px 0 rgba(16, 16, 16, 0.32);
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
}

.blackBg {
  background-color: #212121;
}

.primaryBg {
  background-color: #bd1328;
}

.newPrimaryBg {
  background-color: #ea2a3a;
}
</style>
